import styled from '@emotion/styled'

import { typo } from '~/@common/styles'
import { mediaQuery } from '~/@common/styles/mediaQuery'

export const S = {
  Wrapper: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 32px;
    height: 100%;
    overflow: hidden;
    ${mediaQuery.underTablet} {
      gap: 20px;
      padding: 0 16px;
    }
  `,
  ParentCard: styled.div`
    width: 384px;

    ${mediaQuery.underTablet} {
      width: 100%;
    }

    .card-box {
      background-color: var(--White);
      border-radius: var(--Radius-300);
      overflow: hidden;
    }

    .card-content {
      display: flex;
      gap: 12px;
      padding: 20px 30px;
    }

    .label {
      ${typo.body02}
      color: var(--Colors-Gray-700);
      white-space: nowrap;
    }

    .value {
      ${typo.body02}
      color: var(--Colors-Gray-900);
    }

    .button-container {
      display: flex;
      border-top: 1px solid var(--Colors-Gray-200);

      button:first-of-type {
        border-right: 1px solid var(--Colors-Gray-200);
      }
    }

    .action-button {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 14px 10px;
      width: 50%;
      gap: 2px;
      background-color: var(--White);

      &:first-of-type {
        border-radius: 0 0 0 14px;
      }
      &:last-of-type {
        border-radius: 0 0 14px 0;
      }

      &:active {
        background-color: var(--Colors-Gray-100);
      }

      p {
        text-align: center;
        ${typo.caption01}
        color: var(--Colors-Gray-800);
      }
    }
  `,
  ChildSection: styled.div`
    width: 384px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    height: 100%;
    flex: 1;
    overflow: hidden;
    ${mediaQuery.underTablet} {
      width: 100%;
    }

    .section-title {
      ${typo.body01}
      font-weight: 700;
      color: var(--Colors-Gray-900);
    }
  `,
  ChildList: styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
  `,
  ChildCard: styled.div`
    .card-box {
      background-color: var(--White);
      border-radius: var(--Radius-300);
      overflow: hidden;
    }

    .card-content {
      display: flex;
      flex-direction: column;
      gap: 16px;
      padding: 20px 30px;
    }

    .child-name {
      ${typo.body01}
      font-weight: 700;
      color: var(--Colors-Gray-900);
    }

    .info {
      display: flex;
      gap: 12px;
    }

    .info-label {
      display: flex;
      flex-direction: column;
      gap: 12px;
      color: var(--Colors-Gray-700);
      ${typo.body02}
      white-space: nowrap;
    }

    .info-value {
      display: flex;
      flex-direction: column;
      gap: 12px;
      color: var(--Colors-Gray-900);
      ${typo.body02}

      > p {
        min-height: 21px;
      }
    }
  `,
}
